import { Component } from '@theme/component';

/** @extends {Component<{columns: HTMLDetailsElement[]}>} */
class IlmFooterColumns extends Component {
  #events;
  #media;

  connectedCallback() {
    super.connectedCallback();
    this.#setup();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#setup();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#events?.abort();
  }

  #setup() {
    this.#events?.abort();
    this.#events = new AbortController();
    this.#media = window.matchMedia('(min-width: 750px)');
    this.#media.addEventListener('change', this.#applyLayout, { signal: this.#events.signal });
    this.#applyLayout();
  }

  #applyLayout = () => {
    for (const column of this.refs.columns ?? []) {
      if (!(column instanceof HTMLDetailsElement)) continue;
      column.open = this.#media.matches || column.contains(document.activeElement);
    }
  };
}

if (!customElements.get('ilm-footer-columns')) {
  customElements.define('ilm-footer-columns', IlmFooterColumns);
}
